import logoBusiness from "../../assets/logo-business.png";

import styles from "./BoletimHeader.module.css";

function BoletimHeader({ period }) {
	return (
		<div className={styles.container}>
			<img
				src={logoBusiness}
				className={styles.logo}
				alt="Link"
			/>
			<h1 className={styles.h1}>Boletim de Desempenho / {period}</h1>
		</div>
	);
}

export default BoletimHeader;
